export const PREDEFINED_RACETRACKS = [
  {
    name: "Silverstone",
    location: "Silverstone, Towcester",
    country: "United Kingdom",
    length: 5.891,
    description: "Home of British Motor Racing and the British Grand Prix, featuring the famous corners like Copse and Maggots."
  },
  {
    name: "Brands Hatch",
    location: "Longfield, Kent",
    country: "United Kingdom",
    length: 3.908,
    description: "Historic circuit with two layouts (GP and Indy), known for its natural amphitheater setting."
  },
  {
    name: "Donington Park",
    location: "Castle Donington, Derby",
    country: "United Kingdom",
    length: 4.020,
    description: "Famous for its sweeping curves and elevation changes, home to many motorsport events."
  },
  {
    name: "Goodwood",
    location: "Chichester, West Sussex",
    country: "United Kingdom",
    length: 3.809,
    description: "Historic circuit known for the Festival of Speed and Revival meetings."
  },
  {
    name: "Oulton Park",
    location: "Little Budworth, Cheshire",
    country: "United Kingdom",
    length: 4.307,
    description: "Set in beautiful Cheshire parkland, known for its challenging layout."
  },
  {
    name: "Snetterton",
    location: "Norwich, Norfolk",
    country: "United Kingdom",
    length: 4.779,
    description: "Modern circuit with multiple configurations, featuring long straights and technical corners."
  },
  {
    name: "Thruxton",
    location: "Andover, Hampshire",
    country: "United Kingdom",
    length: 3.793,
    description: "The fastest circuit in the UK, known for its high-speed corners."
  },
  {
    name: "Cadwell Park",
    location: "Louth, Lincolnshire",
    country: "United Kingdom",
    length: 3.477,
    description: "Known as the 'Mini-Nürburgring', famous for its challenging layout and elevation changes."
  },
  {
    name: "Rockingham",
    location: "Corby, Northamptonshire",
    country: "United Kingdom",
    length: 3.141,
    description: "Modern circuit featuring multiple configurations including an oval layout."
  },
  {
    name: "Knockhill",
    location: "Fife, Scotland",
    country: "United Kingdom",
    length: 2.039,
    description: "Scotland's national motorsport centre, known for its tight and twisty layout."
  },
  // Spain
  {
    name: "Circuit de Barcelona-Catalunya",
    location: "Montmeló, Barcelona",
    country: "Spain",
    length: 4.675,
    description: "Home of the Spanish Grand Prix, featuring a mix of high and low-speed corners."
  },
  {
    name: "Circuito de Jerez-Ángel Nieto",
    location: "Jerez de la Frontera",
    country: "Spain",
    length: 4.428,
    description: "Famous for MotoGP, known for its flowing layout and great spectator viewing."
  },
  {
    name: "Circuit Ricardo Tormo",
    location: "Valencia",
    country: "Spain",
    length: 4.005,
    description: "Modern circuit with excellent facilities, hosts the final round of MotoGP."
  },
  {
    name: "Circuito del Jarama",
    location: "San Sebastián de los Reyes, Madrid",
    country: "Spain",
    length: 3.850,
    description: "Historic Spanish circuit, former F1 venue with technical layout."
  },
  {
    name: "Circuito de Navarra",
    location: "Los Arcos, Navarra",
    country: "Spain",
    length: 3.933,
    description: "Modern facility opened in 2010, hosts GT and touring car races."
  },
  {
    name: "Circuito de Albacete",
    location: "Albacete",
    country: "Spain",
    length: 3.550,
    description: "Technical circuit popular for national championships and testing."
  },
  {
    name: "Circuito de Calafat",
    location: "L'Ametlla de Mar, Tarragona",
    country: "Spain",
    length: 3.250,
    description: "Coastal circuit perfect for testing, featuring technical corners."
  },
  {
    name: "Circuito Ascari",
    location: "Ronda, Málaga",
    country: "Spain",
    length: 5.425,
    description: "Exclusive private race resort with challenging layout and luxury facilities."
  },
  {
    name: "Circuito de Cartagena",
    location: "Cartagena, Murcia",
    country: "Spain",
    length: 3.506,
    description: "Popular testing venue, especially for motorcycle racing."
  },
  // Portugal
  {
    name: "Autódromo Internacional do Algarve",
    location: "Portimão",
    country: "Portugal",
    length: 4.653,
    description: "Modern circuit with dramatic elevation changes, hosts F1 and MotoGP races."
  },
  {
    name: "Circuito do Estoril",
    location: "Estoril",
    country: "Portugal",
    length: 4.182,
    description: "Historic track that hosted F1 until 1996, featuring challenging corners."
  },
  {
    name: "Circuito Vasco Sameiro",
    location: "Braga",
    country: "Portugal",
    length: 3.025,
    description: "Technical circuit near Braga, hosts national championships."
  },
  {
    name: "Circuito do Sol",
    location: "Viseu",
    country: "Portugal",
    length: 2.519,
    description: "Compact track perfect for club racing and driver training."
  },
  {
    name: "Autódromo Internacional de Vila Real",
    location: "Vila Real",
    country: "Portugal",
    length: 4.785,
    description: "Challenging street circuit hosting WTCR and national events."
  },
  // France
  {
    name: "Circuit Paul Ricard",
    location: "Le Castellet",
    country: "France",
    length: 5.842,
    description: "Modern circuit with distinctive blue and red run-off areas, technical layout."
  },
  {
    name: "Circuit de la Sarthe",
    location: "Le Mans",
    country: "France",
    length: 13.626,
    description: "Legendary home of the 24 Hours of Le Mans, world's oldest endurance race."
  },
  {
    name: "Circuit de Magny-Cours",
    location: "Magny-Cours",
    country: "France",
    length: 4.411,
    description: "Former F1 venue known for its technical sections and high-speed chicanes."
  },
  {
    name: "Circuit de Nevers Magny-Cours",
    location: "Nevers",
    country: "France",
    length: 4.411,
    description: "Modern facility that hosted F1 French Grand Prix from 1991 to 2008."
  },
  {
    name: "Circuit Dijon-Prenois",
    location: "Prenois",
    country: "France",
    length: 3.800,
    description: "Historic circuit known for great F1 battles, featuring elevation changes."
  },
  {
    name: "Circuit de Lédenon",
    location: "Lédenon",
    country: "France",
    length: 3.151,
    description: "Technical track with significant elevation changes, unique counter-clockwise layout."
  },
  {
    name: "Circuit Pau-Arnos",
    location: "Arnos",
    country: "France",
    length: 3.030,
    description: "Modern circuit in the Pyrénées region, technical and challenging."
  },
  {
    name: "Circuit de Nogaro",
    location: "Nogaro",
    country: "France",
    length: 3.636,
    description: "Technical circuit hosting GT and touring car races."
  },
  {
    name: "Circuit du Val de Vienne",
    location: "Le Vigeant",
    country: "France",
    length: 3.768,
    description: "Modern circuit with varied corners and good facilities."
  },
  // Germany
  {
    name: "Nürburgring",
    location: "Nürburg",
    country: "Germany",
    length: 5.148,
    description: "Iconic GP circuit next to the legendary Nordschleife, rich in motorsport history."
  },
  {
    name: "Nürburgring Nordschleife",
    location: "Nürburg",
    country: "Germany",
    length: 20.832,
    description: "The legendary 'Green Hell', world's most challenging race track."
  },
  {
    name: "Hockenheimring",
    location: "Hockenheim",
    country: "Germany",
    length: 4.574,
    description: "Historic circuit that has hosted numerous F1 races, known for its stadium section."
  },
  {
    name: "Sachsenring",
    location: "Hohenstein-Ernstthal",
    country: "Germany",
    length: 3.671,
    description: "Home of the German MotoGP, technical track with elevation changes."
  },
  {
    name: "Lausitzring",
    location: "Klettwitz",
    country: "Germany",
    length: 4.345,
    description: "Modern circuit with multiple configurations, hosts DTM races."
  },
  {
    name: "Oschersleben",
    location: "Oschersleben",
    country: "Germany",
    length: 3.667,
    description: "Modern circuit hosting DTM and touring car races."
  },
  {
    name: "Norisring",
    location: "Nuremberg",
    country: "Germany",
    length: 2.300,
    description: "Famous street circuit, known as the 'Monaco of Germany'."
  },
  {
    name: "Bilster Berg",
    location: "Bad Driburg",
    country: "Germany",
    length: 4.207,
    description: "Modern private circuit designed by Hermann Tilke with dramatic elevation changes."
  },
  {
    name: "Red Bull Ring",
    location: "Spielberg",
    country: "Austria",
    length: 4.318,
    description: "Modern F1 circuit in the Styrian mountains, known for fast corners."
  },
  // Italy
  {
    name: "Autodromo Nazionale Monza",
    location: "Monza",
    country: "Italy",
    length: 5.793,
    description: "The Temple of Speed, historic F1 venue known for high-speed racing."
  },
  {
    name: "Autodromo Internazionale del Mugello",
    location: "Mugello",
    country: "Italy",
    length: 5.245,
    description: "Ferrari-owned circuit, hosts MotoGP, known for fast flowing corners."
  },
  {
    name: "Autodromo Enzo e Dino Ferrari",
    location: "Imola",
    country: "Italy",
    length: 4.909,
    description: "Historic circuit that has hosted F1, featuring challenging elevation changes."
  },
  {
    name: "Misano World Circuit Marco Simoncelli",
    location: "Misano Adriatico",
    country: "Italy",
    length: 4.226,
    description: "Popular MotoGP venue, technical track near the Adriatic coast."
  },
  {
    name: "Autodromo Vallelunga",
    location: "Campagnano di Roma",
    country: "Italy",
    length: 4.085,
    description: "Technical circuit near Rome, important for Italian motorsport."
  },
  // More Italy
  {
    name: "Autodromo di Pergusa",
    location: "Pergusa, Sicily",
    country: "Italy",
    length: 4.950,
    description: "Unique circuit around a lake, known for its high speeds and historic races."
  },
  {
    name: "Circuito del Levante",
    location: "Binetto, Bari",
    country: "Italy",
    length: 1.577,
    description: "Technical short circuit in southern Italy, popular for testing."
  },
  {
    name: "Autodromo dell'Umbria",
    location: "Magione",
    country: "Italy",
    length: 2.507,
    description: "Challenging technical circuit in the heart of Italy."
  },
  // Belgium
  {
    name: "Circuit de Spa-Francorchamps",
    location: "Stavelot",
    country: "Belgium",
    length: 7.004,
    description: "Iconic F1 circuit featuring the famous Eau Rouge corner, known as one of the most challenging tracks."
  },
  {
    name: "Circuit Zolder",
    location: "Heusden-Zolder",
    country: "Belgium",
    length: 4.011,
    description: "Historic circuit that has hosted F1, now a popular venue for GT and touring car races."
  },
  {
    name: "Mettet Circuit",
    location: "Mettet",
    country: "Belgium",
    length: 2.280,
    description: "Modern circuit hosting various national championships and motorcycle events."
  },
  // Netherlands
  {
    name: "Circuit Zandvoort",
    location: "Zandvoort",
    country: "Netherlands",
    length: 4.259,
    description: "Coastal circuit with banked corners, home of the Dutch F1 Grand Prix."
  },
  {
    name: "TT Circuit Assen",
    location: "Assen",
    country: "Netherlands",
    length: 4.555,
    description: "The 'Cathedral of Speed', legendary MotoGP venue with rich history."
  },
  // Switzerland
  {
    name: "Circuit Bremgarten",
    location: "Bern",
    country: "Switzerland",
    length: 7.280,
    description: "Historic circuit used until 1954 when motor racing was banned in Switzerland."
  },
  // Austria
  {
    name: "Salzburgring",
    location: "Salzburg",
    country: "Austria",
    length: 4.241,
    description: "Fast circuit in the Austrian mountains, known for motorcycle racing."
  },
  // Czech Republic
  {
    name: "Autodrom Most",
    location: "Most",
    country: "Czech Republic",
    length: 4.219,
    description: "Modern circuit hosting European touring car and truck racing events."
  },
  {
    name: "Masaryk Circuit",
    location: "Brno",
    country: "Czech Republic",
    length: 5.403,
    description: "Historic venue hosting MotoGP, known for its natural setting and elevation changes."
  },
  // Hungary
  {
    name: "Hungaroring",
    location: "Mogyoród",
    country: "Hungary",
    length: 4.381,
    description: "F1 circuit known for its tight and twisty layout, first behind the Iron Curtain."
  },
  // Slovakia
  {
    name: "Slovakia Ring",
    location: "Orechová Potôň",
    country: "Slovakia",
    length: 5.922,
    description: "Modern circuit with long straights and technical sections, hosts WTCR."
  },
  // Croatia
  {
    name: "Grobnik Circuit",
    location: "Rijeka",
    country: "Croatia",
    length: 4.168,
    description: "Challenging circuit near the Adriatic coast, popular for motorcycle racing."
  },
  // Poland
  {
    name: "Tor Poznań",
    location: "Poznań",
    country: "Poland",
    length: 4.083,
    description: "Poland's premier racing circuit, hosting national championships."
  },
  // Sweden
  {
    name: "Anderstorp Raceway",
    location: "Anderstorp",
    country: "Sweden",
    length: 4.025,
    description: "Former F1 venue known for its unique aircraft runway straight."
  },
  {
    name: "Mantorp Park",
    location: "Mantorp",
    country: "Sweden",
    length: 3.106,
    description: "Historic Swedish circuit hosting touring car and motorcycle races."
  },
  // Finland
  {
    name: "KymiRing",
    location: "Iitti",
    country: "Finland",
    length: 4.600,
    description: "Modern circuit designed for MotoGP, featuring challenging elevation changes."
  },
  // Russia
  {
    name: "Sochi Autodrom",
    location: "Sochi",
    country: "Russia",
    length: 5.848,
    description: "Modern F1 circuit built around the Olympic Park."
  },
  {
    name: "Moscow Raceway",
    location: "Moscow",
    country: "Russia",
    length: 3.931,
    description: "Modern circuit designed by Hermann Tilke, hosts DTM and WTCC."
  },
  // Turkey
  {
    name: "Istanbul Park",
    location: "Istanbul",
    country: "Turkey",
    length: 5.338,
    description: "Modern circuit featuring the challenging Turn 8, has hosted F1 races."
  },
  // United Arab Emirates
  {
    name: "Yas Marina Circuit",
    location: "Abu Dhabi",
    country: "United Arab Emirates",
    length: 5.281,
    description: "Modern F1 circuit featuring a hotel and marina, hosts the season finale."
  },
  {
    name: "Dubai Autodrome",
    location: "Dubai",
    country: "United Arab Emirates",
    length: 5.390,
    description: "Modern circuit with multiple configurations, hosts GT and endurance races."
  },
  // Japan
  {
    name: "Suzuka Circuit",
    location: "Suzuka",
    country: "Japan",
    length: 5.807,
    description: "Legendary figure-8 circuit, home of the Japanese Grand Prix."
  },
  {
    name: "Fuji Speedway",
    location: "Oyama",
    country: "Japan",
    length: 4.563,
    description: "Historic circuit in the shadow of Mount Fuji, modernized by Toyota."
  },
  {
    name: "Twin Ring Motegi",
    location: "Motegi",
    country: "Japan",
    length: 4.801,
    description: "Modern Honda-owned facility featuring both road course and oval."
  },
  // South Korea
  {
    name: "Korea International Circuit",
    location: "Yeongam",
    country: "South Korea",
    length: 5.615,
    description: "Former F1 circuit designed by Hermann Tilke."
  },
  // Australia
  {
    name: "Albert Park Circuit",
    location: "Melbourne",
    country: "Australia",
    length: 5.303,
    description: "Semi-permanent street circuit hosting the Australian Grand Prix."
  },
  {
    name: "Mount Panorama Circuit",
    location: "Bathurst",
    country: "Australia",
    length: 6.213,
    description: "Legendary mountain circuit, home of the Bathurst 1000."
  },
  {
    name: "The Bend Motorsport Park",
    location: "Tailem Bend",
    country: "Australia",
    length: 7.770,
    description: "Modern facility with multiple configurations, longest permanent circuit in Australia."
  },
  // New Zealand
  {
    name: "Pukekohe Park Raceway",
    location: "Pukekohe",
    country: "New Zealand",
    length: 2.910,
    description: "Historic circuit hosting Supercars Championship events."
  },
  // Brazil
  {
    name: "Autódromo José Carlos Pace",
    location: "São Paulo",
    country: "Brazil",
    length: 4.309,
    description: "Interlagos circuit, historic F1 venue known for dramatic races."
  },
  {
    name: "Autódromo Internacional Nelson Piquet",
    location: "Rio de Janeiro",
    country: "Brazil",
    length: 3.336,
    description: "Former F1 venue named after the Brazilian champion."
  },
  // Argentina
  {
    name: "Autódromo Oscar y Juan Gálvez",
    location: "Buenos Aires",
    country: "Argentina",
    length: 4.259,
    description: "Historic circuit that has hosted F1 and various international events."
  },
  // Mexico
  {
    name: "Autódromo Hermanos Rodríguez",
    location: "Mexico City",
    country: "Mexico",
    length: 4.304,
    description: "Historic circuit modernized for F1, featuring the unique stadium section."
  }
]; 